import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { SingleSelect, ButtonSecondary, HorizontalFlex } from 'smartsuite-ui';
import SaveAsModal from './SaveAsModal';

export default function SavedFiltersContainer(props) {
    const { t } = useTranslation('translation');
    const [isSaveAsModalVisible, setIsSaveAsModalVisible] = useState(false);
    const [visibleOverwriteOptions, setVisibleOverwriteOptions] = useState([]);

    useEffect(() => {
        setVisibleOverwriteOptions(
            props.savedSearchNames.filter(
                (savedSearchName) =>
                    savedSearchName.key && savedSearchName.key !== 'Default'
            )
        );
    }, [props.savedSearchNames]);

    const onChange = (selectedValue) => {
        props.loadSavedSearch(selectedValue.key);
    };

    const onSave = (name, isSaveNew) => {
        setIsSaveAsModalVisible(false);
        props.onSave(name, isSaveNew);
    };

    function getModifiedValue() {
        if (!props.isSavedSearchModified) {
            return props.selectedValue;
        }
        const modifiedOption = props.savedSearchNames.find(
            (x) => x.name === props.selectedValue.name
        );
        if (!modifiedOption) {
            return props.selectedValue;
        }
        return {
            name: `${modifiedOption.name} ${t('modified')}`,
            key: modifiedOption.key,
        };
    }

    return (
        <HorizontalFlex
            cssClassModifiers={['align-flex-start', 'justify-flex-end']}
        >
            <SingleSelect
                options={props.savedSearchNames}
                valueField="key"
                textField="name"
                onChange={onChange}
                value={getModifiedValue()}
                hasBlankOption={false}
                isClearable={false}
            />
            <ButtonSecondary
                disabled={props.isSaveDisabled}
                onClick={() => setIsSaveAsModalVisible(true)}
            >
                {t('save')}
            </ButtonSecondary>
            <SaveAsModal
                onConfirm={onSave}
                onDismiss={() => setIsSaveAsModalVisible(false)}
                isModalVisible={isSaveAsModalVisible}
                modifiedFrom={props.selectedValue.modifiedFrom}
                pageTitle={props.pageTitle}
                siteMapKey={props.siteMapKey}
                visibleOverwriteOptions={visibleOverwriteOptions}
            />
        </HorizontalFlex>
    );
}

SavedFiltersContainer.propTypes = {
    isSaveDisabled: PropTypes.bool.isRequired,
    isSavedSearchModified: PropTypes.bool.isRequired,
    loadSavedSearch: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    pageTitle: PropTypes.string.isRequired,
    savedSearchNames: PropTypes.instanceOf(Array).isRequired,
    selectedValue: PropTypes.instanceOf(Object).isRequired,
    siteMapKey: PropTypes.string,
};
